import { DataBean } from "../DataBean";

export class SalesType extends DataBean {


    public async getSalesTypeConstants(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSalesTypeConstants_Number", [args]);
    }


}